import type { UseFormRegisterReturn } from 'react-hook-form';
import { z } from 'zod';

/**
 * Código de 3 letras del consecutivo `AAA-PPP-NNNNN` (change-51, ADR-015): el de la inmobiliaria
 * (AAA) y el del proyecto (PPP). Mismo contrato que el DTO del API: se normaliza a mayúsculas y
 * exige 3 letras A-Z. El API sigue siendo la autoridad (unicidad y código congelado).
 */
export const MENSAJE_CODIGO_INVALIDO = 'El código debe tener exactamente 3 letras (A-Z).';

export const codigoConsecutivoSchema = z
  .string()
  .trim()
  .min(1, 'Ingrese el código')
  .transform((v) => v.toUpperCase())
  .pipe(z.string().regex(/^[A-Z]{3}$/, MENSAJE_CODIGO_INVALIDO));

/** Ayuda común del campo: la regla de edición de ADR-015. */
export const AYUDA_CODIGO =
  '3 letras. Forma el consecutivo de los documentos; no se puede cambiar después de emitir el primero.';

/** Envuelve el `register` del campo para escribir siempre en mayúsculas mientras se teclea. */
export function registroEnMayusculas<T extends string>(
  campo: UseFormRegisterReturn<T>,
): UseFormRegisterReturn<T> {
  return {
    ...campo,
    onChange: (event) => {
      const input = event.target as HTMLInputElement;
      input.value = input.value.toUpperCase();
      return campo.onChange(event);
    },
  };
}
